if (!customElements.get('header-component')) {
  class Header extends HTMLElement {
    constructor () {
      super()
      this.header = this
      this.headerInner = this.querySelector('.hd-HeaderInner')
      this.menuItems = this.querySelectorAll('.hd-MenuItem[data-mega-menu="true"]')
      this.hoverTimeout = null
      this.lastScrollTop = 0
      this.scrollThreshold = 50 // Minimum scroll amount to trigger header show/hide

      this.bindEvents()
    }

    bindEvents () {
      if (this.header) {
        window.addEventListener('scroll', this.onScroll.bind(this))
      }

      // Add hover events for menu items with timeout
      this.menuItems.forEach((item) => {
        const megaMenu = item.querySelector('.hd-MegaMenu')

        if (megaMenu) {
          item.addEventListener('mouseenter', () => {
            this.menuItems.forEach((item) => {
              item.classList.remove('hd-MenuItem_Hover')
            })
            // Clear any existing timeout
            if (this.hoverTimeout) {
              clearTimeout(this.hoverTimeout)
              this.hoverTimeout = null
            }
            item.classList.add('hd-MenuItem_Hover')
            this.headerInner.classList.add('hd-HeaderInner_Hover')
          })

          item.addEventListener('mouseleave', () => {
            // Set a timeout to remove the hover class
            this.hoverTimeout = setTimeout(() => {
              item.classList.remove('hd-MenuItem_Hover')
              this.headerInner.classList.remove('hd-HeaderInner_Hover')
            }, 150) // 150ms delay before removing hover state
          })
        }
      })
    }

    onScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      this.headerInner.classList.remove('hd-HeaderInner_Hover')
      this.updateStickyState(scrollTop)
      setTimeout(() => {
        document.querySelector('header-height')?.update()
      }, 350)
    }

    updateStickyState (scrollTop) {
      // Update sticky state
      if (document.body.classList.contains('drawer-open')) {
        this.header.classList.add('is-Sticky')
        this.header.style.transform = 'translateY(0)'
        return
      }

      if (scrollTop > 0) {
        this.header.classList.add('is-Sticky')
        document.body.classList.add('is-HeaderSticky')
      } else {
        this.header.classList.remove('is-Sticky')
        document.body.classList.remove('is-HeaderSticky')
      }

      const scrollDelta = scrollTop - this.lastScrollTop
      // Handle header show/hide based on scroll direction
      if (Math.abs(scrollDelta) > this.scrollThreshold) {
        if (scrollDelta > 0 && scrollTop > 100) {
          // Scrolling down - hide header
          this.header.style.transform = 'translateY(-100%)'
        } else {
          // Scrolling up - show header
          this.header.style.transform = 'translateY(0)'
        }
        this.lastScrollTop = scrollTop
      }
    }
  }

  class HeaderHeight extends HTMLElement {
    constructor () {
      super()
      this.announcement = document.querySelector('[data-announcement]')

      this.init()
    }

    get header () {
      return window.innerWidth > 1200 ? document.querySelector('[data-header-desktop]') : document.querySelector('[data-header-mobile]')
    }

    init () {
      window.addEventListener('scroll', this.update.bind(this))
      window.addEventListener('resize', this.update.bind(this))

      // Initial height calculation
      this.update()
    }

    update () {
      const headerHeight = this.header ? this.header.offsetHeight : 0
      const announcementHeight = this.announcement ? this.announcement.offsetHeight : 0
      const computedStyle = window.getComputedStyle(this.header)

      document.documentElement.style.setProperty('--Header_Top', `${this.header.getBoundingClientRect().top + parseInt(computedStyle.paddingTop)}px`)
      document.documentElement.style.setProperty('--Header_Height', `${headerHeight}px`)
      document.documentElement.style.setProperty('--Announcement_Height', `${announcementHeight}px`)
      document.documentElement.style.setProperty('--Header_With_Announcement', `${headerHeight + announcementHeight}px`)
    }
  }

  customElements.define('header-component', Header)
  customElements.define('header-height', HeaderHeight)
}
